module.exports = __webpack_public_path__ + "img/home-index-menu11.664cfc61.png";